import { useDisclosure } from '@chakra-ui/hooks';
import { Box, Text } from '@chakra-ui/layout';
// import { ChakraProvider } from "@chakra-ui/provider";
import { useToast } from '@chakra-ui/toast';
import React from 'react';
import GoogleFontLoader from 'react-google-font-loader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { customFonts, selectCustomFonts } from '../../redux/customFontsSlice';

import CanvasCSSVariablesImport from '../canvas/CanvasCSSVariablesImport';
import ImagesImport from '../canvas/ImagesImport';
import PopoverEditComponent from '../popover/PopoverEditComponent';
import DragDropContextContainerSA from './DragDropContextContainerSA';
import HeaderSA from './HeaderSA';
import { getAuthHeader } from '../../utils/auth-token';

const EditorSA = ({ userInfo }) => {
	const toast = useToast();
	const { viewId } = useParams();
	const dispatch = useDispatch();
	//disclosure do modal de criar/editar projeto
	const { onOpen, onClose, isOpen } = useDisclosure();
	const [isDebugActive, setIsDebugActive] = React.useState(false);
	const fonts = useSelector(customFonts);
	const headerProps = {
		isOpen,
		onOpen,
		onClose,
		viewId,
		userInfo,
		isDebugActive,
		setIsDebugActive,
		leftDrawerIsOpen: true,
		setLeftDrawerIsOpen: () => null,
	};

	React.useEffect(() => {
		fetch(`${process.env.REACT_APP_COMPILER_URL}/api/tachyons/getJSON/${viewId}`, { headers: getAuthHeader() })
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp?.customFonts?.length) {
					dispatch(selectCustomFonts(resp.customFonts));
				}
			})
			.catch(() => {
				toast(fontError);
			});
	}, []);

	React.useEffect(() => {
		console.log(fonts);
	}, [fonts]);

	return (
		<React.Fragment>
			{/* <IconPackImport /> */}
			<ImagesImport viewId={viewId} />
			{fonts?.length && (
				<GoogleFontLoader
					fonts={fonts.filter((f) => !['sans-serif', 'palatino', 'calibri'].includes(f.font.toLowerCase()))}
				/>
			)}
			{<CanvasCSSVariablesImport {...{ viewId }} />}

			<HeaderSA {...headerProps} />
			<Box
				transition={'0.2s'}
				position={'relative'}
				d={'flex'}
				ml={0}
				mr={'0'}
				justifyContent={'space-between'}
				h={'100%'}
				bg={'#EDF2F7'}
				className="DragDropContainerContext"
			>
				{/* {VMMode ? <VisualizationModeComponent {...{ viewId }} /> : <DragDropContextContainer {...{ viewId, userInfo, leftDrawerIsOpen, setLeftDrawerIsOpen, recentCommits, setRecentCommits, isDebugActive, recentCommitsIsOpen, setRecentCommitsIsOpen, recentCommitsLoaded }} />} */}
				{/* <ChakraProvider theme={theme} overflow={"hidden"} resetCSS={false}> */}
				<PopoverEditComponent />
				{/* </ChakraProvider> */}
				<DragDropContextContainerSA {...{ viewId, userInfo, isDebugActive }} />
			</Box>
		</React.Fragment>
	);
};

const fontError = {
	title: `Ocorreu um erro ao tentar recuperar as fontes`,
	status: 'error',
	duration: 10000,
	isClosable: true,
	position: 'top',
};
export default EditorSA;
